module.exports = __webpack_public_path__ + "res/img/cover.fa73eddf.png";